import { useRouter } from 'next/router';
import { Product } from '@/creditflowresearch/domain/Product';
import Badge from '@/creditflowresearch/ui/common/components/atoms/Badge';

interface IProductBadgeProps {
  text: string,
  productColor: string,
  productId?: string,
  isActive?: boolean,
}

const ProductBadge = ({ text, productColor, productId, isActive }: IProductBadgeProps) => {
  const { query } = useRouter();
  const queryProducts = query.products;

  const isProductActive = productId && queryProducts
    ? (() => {
        const productAbbreviation = Product.getAbbreviation(productId);
        if (!productAbbreviation) return false;
        return (queryProducts as string[]).includes(productAbbreviation);
      })()
    : isActive ?? false;

  return (
    <Badge text={ text } color={ productColor } isActive={ isProductActive } />
  );
};

export default ProductBadge;
